import { render, staticRenderFns } from "./dealedTask.vue?vue&type=template&id=3b88d064&"
import script from "./dealedTask.vue?vue&type=script&lang=js&"
export * from "./dealedTask.vue?vue&type=script&lang=js&"
import style0 from "./dealedTask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports